import React from 'react';
import Joi from 'joi-browser';
import Form from '../../../../common/form';
import Spinner from '../../../../common/spinner';

class GetUserByWalletForm extends Form {
	state = {
		data: {
			wallet: '',
		},
		errors: {},
	};

	schema = {
		wallet: Joi.string().required().label('Wallet'),
	};

	doSubmit = () => this.props.onSubmit(this.state.data);

	componentWillUnmount() {
		// fix Warning: Can't perform a React state update on an unmounted component
		this.setState = (state, callback) => {
			return;
		};
	}

	render() {
		const { isLoading, theme } = this.props;

		return (
			<form
				className='row'
				onSubmit={this.handleSubmit}>
				<div className='col-md-8 offset-md-2 col-12 text-start'>
					<div className='mt-4'>
						{this.renderInput({
							name: 'wallet',
							label: 'Wallet',
						})}
					</div>

					<div className='my-3 text-center'>
						{this.renderButton(
							'Search user by wallet',
							`btn btn-set2-${theme} w-100`,
							isLoading && <Spinner content='Loading...' />
						)}
					</div>
				</div>
			</form>
		);
	}
}

export default GetUserByWalletForm;
